import { Directive, signal } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';

const noop = (): void => undefined;
const noopChange = <T>(_value: T | null): void => undefined;

@Directive()
export abstract class BaseControlValueAccessorDirective<T>
  implements ControlValueAccessor
{
  private readonly internalValue = signal<T | null>(null);
  private readonly internalDisabled = signal(false);

  public readonly value = this.internalValue.asReadonly();
  public readonly disabled = this.internalDisabled.asReadonly();

  protected onChange: (value: T | null) => void = noopChange;
  protected onTouched: () => void = noop;

  public writeValue(value: T | null): void {
    this.internalValue.set(value);
  }

  public registerOnChange(fn: (value: T | null) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.internalDisabled.set(isDisabled);
  }

  protected updateValue(value: T | null): void {
    if (this.internalValue() === value) {
      return;
    }

    this.internalValue.set(value);
    this.onChange(value);
  }

  protected markAsTouched(): void {
    this.onTouched();
  }
}
